import { render } from "./ModulInfoText3Spaltig.vue?vue&type=template&id=5c58c6e1"
import script from "./ModulInfoText3Spaltig.vue?vue&type=script&lang=js"
export * from "./ModulInfoText3Spaltig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__